import { FileExclamationOutlined } from "@ant-design/icons";
import { Tooltip, theme } from "antd";

const { useToken } = theme;

interface OutstandingClaimsIndicatorProps {
    readonly hasOutstandingClaims: boolean;
}

/** In PMS-integrated sessions, denotes a patient with outstanding (unpaid) insurance claims. */
export const OutstandingClaimsIndicator = ({ hasOutstandingClaims }: OutstandingClaimsIndicatorProps) => {
    const { token } = useToken();

    return hasOutstandingClaims ? (
        <Tooltip title="This patient has an outstanding insurance claim.">
            <FileExclamationOutlined style={{ color: token.colorWarning }} />
        </Tooltip>
    ) : null;
};
